import React, { useState } from 'react';
import { Mail, Phone, MapPin, Smartphone, Download, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { logoUrl } from '../mockData';
import axios from 'axios';

const Footer = () => {
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [demoPassword, setDemoPassword] = useState('');
  const [demoError, setDemoError] = useState('');
  const [showCredentials, setShowCredentials] = useState(false);
  
  // Brochure form state
  const [brochureName, setBrochureName] = useState('');
  const [brochureEmail, setBrochureEmail] = useState('');
  const [brochureSubmitting, setBrochureSubmitting] = useState(false);
  const [brochureSuccess, setBrochureSuccess] = useState(false);
  const [brochureError, setBrochureError] = useState('');
  const [brochurePrivacy, setBrochurePrivacy] = useState(false);

  const handleBrochureSubmit = async (e) => {
    e.preventDefault();
    
    if (!brochureName.trim() || !brochureEmail.trim()) {
      setBrochureError('Compila tutti i campi');
      return;
    }
    
    if (!brochurePrivacy) {
      setBrochureError("Devi accettare l'Informativa Privacy per procedere");
      return;
    }
    
    setBrochureSubmitting(true);
    setBrochureError('');
    
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/brochure-request`, {
        name: brochureName,
        email: brochureEmail
      });
      setBrochureSuccess(true);
    } catch (error) {
      console.error('Errore:', error);
      setBrochureError('Errore durante l\'invio. Riprova.');
    } finally {
      setBrochureSubmitting(false);
    }
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-[#17536B] to-[#0D2F3D] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Logo & Description */}
          <div className="lg:col-span-1">
            <img
              src={logoUrl}
              alt="Assietica"
              className="h-20 w-auto mb-6"
            />
            <p className="text-white/80 leading-relaxed mb-4">
              Assietica Società Cooperativa - Cooperativa di Servizi Assicurativi e Società Benefit. 
              Consulenza assicurativa specializzata per Enti del Terzo Settore e Cooperative.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 bg-white/10 backdrop-blur-md rounded-full text-xs border border-white/20">
                Società Benefit
              </span>
              <span className="px-3 py-1 bg-white/10 backdrop-blur-md rounded-full text-xs border border-white/20">
                Società Cooperativa
              </span>
              <span className="px-3 py-1 bg-white/10 backdrop-blur-md rounded-full text-xs border border-white/20">
                Agenzia Assimoco
              </span>
            </div>
          </div>

          {/* Column 2 - Sedi */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#F9D424]">Le Nostre Sedi</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="text-[#3AAFA9] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-white font-semibold">Macomer</p>
                  <p className="text-white/80 text-sm">Viale Antonio Gramsci 8/G</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="text-[#3AAFA9] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-white font-semibold">Bosa</p>
                  <p className="text-white/80 text-sm">Via Azuni, 14</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="text-[#3AAFA9] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-white font-semibold">Cagliari</p>
                  <p className="text-white/80 text-sm">Piazza Unione Sarda, 39</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contatti */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#F9D424]">Contatti</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="text-[#3AAFA9] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-white/60 text-xs mb-1">Telefono fisso</p>
                  <a href="tel:+390785747193" className="text-white/80 hover:text-white transition-colors duration-300">
                    0785 747193
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Smartphone className="text-[#3AAFA9] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="text-white/60 text-xs mb-1">Cellulare agenzia</p>
                  <a href="tel:+393737288673" className="text-white/80 hover:text-white transition-colors duration-300">
                    373 7288673
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="text-[#3AAFA9] flex-shrink-0 mt-1" size={18} />
                <div>
                  <a href="mailto:agenzia@assietica.it" className="text-white/80 hover:text-white transition-colors duration-300">
                    agenzia@assietica.it
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Column 4 - Link Rapidi */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#F9D424]">Link Rapidi</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-white/80 hover:text-white transition-colors duration-300"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('team')}
                  className="text-white/80 hover:text-white transition-colors duration-300"
                >
                  Chi Siamo
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('benefici')}
                  className="text-white/80 hover:text-white transition-colors duration-300"
                >
                  Servizi
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('societa-benefit')}
                  className="text-white/80 hover:text-white transition-colors duration-300"
                >
                  Società Benefit
                </button>
              </li>
              <li>
                <Link
                  to="/rete-di-accordi"
                  data-testid="footer-rete-accordi-link"
                  className="text-white/80 hover:text-white transition-colors duration-300"
                >
                  Rete di Accordi
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contatti')}
                  className="text-white/80 hover:text-white transition-colors duration-300"
                >
                  Contatti
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          {/* Disclaimer IVASS */}
          <div className="bg-white/5 backdrop-blur-md rounded-lg p-6 mb-6 border border-white/10">
            <p className="text-sm text-white/70 leading-relaxed mb-4">
              <strong className="text-white">Messaggio promozionale.</strong> Prima della sottoscrizione 
              leggere il Set Informativo disponibile presso l'agenzia o sul sito dell'impresa. 
              Le informazioni fornite hanno carattere generale e non costituiscono consulenza personalizzata. 
              Per una valutazione completa, contatta i nostri consulenti.
            </p>
            <p className="text-sm text-white/70 leading-relaxed mb-4">
              <strong className="text-white">Intermediario iscritto al RUI n. A000480096 — Sezione A (Agenti) — data di iscrizione 07/02/2014</strong>, soggetto al controllo dell'organo di vigilanza IVASS.{' '}
              <a 
                data-testid="footer-verifica-rui-link"
                href="https://servizi.ivass.it/RuirPubblica/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#3AAFA9] hover:text-[#F9D424] underline transition-colors duration-300"
              >
                Verifica l'iscrizione sul RUI (servizi.ivass.it)
              </a>
            </p>
            <div data-testid="footer-dati-legali" className="text-xs text-white/60 leading-relaxed space-y-1 pt-3 border-t border-white/10">
              <p>
                <strong className="text-white/80">Assietica Società Cooperativa — Società Benefit</strong>
              </p>
              <p>Sede Legale: Viale Antonio Gramsci 8/G, 08015 Macomer (NU) · P.IVA / C.F.: 01435480916</p>
              <p>
                Tel: <a href="tel:+390785747193" className="underline hover:text-white">0785 747193</a> · Email: <a href="mailto:agenzia@assietica.it" className="underline hover:text-white">agenzia@assietica.it</a> · PEC: <a href="mailto:cdsp@pec.confcooperative.it" className="underline hover:text-white">cdsp@pec.confcooperative.it</a>
              </p>
            </div>
          </div>

          {/* Documenti Legali Box */}
          <div className="bg-white/5 backdrop-blur-md rounded-lg p-6 mb-8 border border-white/10">
            <h4 className="text-white font-semibold mb-4">Documenti Legali</h4>
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/privacy-policy" 
                className="text-white/80 hover:text-[#3AAFA9] transition-colors duration-300 text-sm underline"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/cookie-policy" 
                className="text-white/80 hover:text-[#3AAFA9] transition-colors duration-300 text-sm underline"
              >
                Cookie Policy
              </Link>
              <Link 
                to="/termini-condizioni" 
                className="text-white/80 hover:text-[#3AAFA9] transition-colors duration-300 text-sm underline"
              >
                Termini e Condizioni d'uso
              </Link>
              <Link 
                to="/precontrattuale" 
                className="text-white/80 hover:text-[#3AAFA9] transition-colors duration-300 text-sm underline"
              >
                Precontrattuale
              </Link>
              <Link 
                to="/reclami" 
                data-testid="footer-reclami-link"
                className="text-white/80 hover:text-[#3AAFA9] transition-colors duration-300 text-sm underline"
              >
                Reclami
              </Link>
              <Link 
                to="/trasparenza-reclami" 
                className="text-white/80 hover:text-[#3AAFA9] transition-colors duration-300 text-sm underline"
              >
                Trasparenza e Reclami
              </Link>
              <Link 
                to="/trasparenza-ia" 
                className="text-white/80 hover:text-[#3AAFA9] transition-colors duration-300 text-sm underline"
              >
                Trasparenza IA
              </Link>
              <button
                data-testid="manage-cookies-btn"
                onClick={() => window.dispatchEvent(new Event('open-cookie-banner'))}
                className="text-white/80 hover:text-[#3AAFA9] transition-colors duration-300 text-sm underline"
              >
                Gestisci preferenze cookie
              </button>
            </div>
          </div>

          {/* Chi Siamo Links Box */}
          <div className="bg-white/5 backdrop-blur-md rounded-lg p-6 mb-8 border border-white/10">
            <h4 className="text-white font-semibold mb-4">Scopri la Nostra Identità</h4>
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/mission" 
                className="text-white/80 hover:text-[#F9D424] transition-colors duration-300 text-sm underline"
              >
                La Nostra Mission
              </Link>
              <Link 
                to="/societa-benefit" 
                className="text-white/80 hover:text-[#F9D424] transition-colors duration-300 text-sm underline"
              >
                Perché Società Benefit
              </Link>
              <Link 
                to="/societa-cooperativa" 
                className="text-white/80 hover:text-[#5FB76E] transition-colors duration-300 text-sm underline"
              >
                Perché Cooperativa
              </Link>
            </div>
          </div>

          {/* Area Servizi Riservati */}
          <div className="bg-gradient-to-r from-[#5FB76E]/20 to-[#3AAFA9]/20 backdrop-blur-md rounded-lg p-6 mb-8 border border-[#5FB76E]/30">
            <h4 className="text-white font-semibold mb-4">Area Servizi Riservati</h4>
            <p className="text-white/70 text-sm mb-4">Gestionali ETS / Volontari / ecc...</p>
            <button 
              onClick={() => setShowDemoModal(true)}
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#5FB76E] to-[#3AAFA9] text-white font-semibold rounded-lg hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
              Demo Gestionale ETS
            </button>
          </div>

          {/* Scarica Brochure */}
          <div className="bg-gradient-to-r from-[#E67E22]/20 to-[#E74C3C]/20 backdrop-blur-md rounded-lg p-6 mb-8 border border-[#E67E22]/30">
            <div className="flex items-center mb-4">
              <Download className="w-5 h-5 text-[#E67E22] mr-2" />
              <h4 className="text-white font-semibold">Scarica la Brochure del Gestionale per ETS</h4>
            </div>
            
            {!brochureSuccess ? (
              <form onSubmit={handleBrochureSubmit} className="space-y-3">
                <input
                  type="text"
                  value={brochureName}
                  onChange={(e) => setBrochureName(e.target.value)}
                  placeholder="Il tuo nome"
                  className="w-full px-4 py-2 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/50 focus:ring-2 focus:ring-[#E67E22] focus:border-transparent text-sm"
                />
                <input
                  type="email"
                  value={brochureEmail}
                  onChange={(e) => setBrochureEmail(e.target.value)}
                  placeholder="La tua email"
                  className="w-full px-4 py-2 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/50 focus:ring-2 focus:ring-[#E67E22] focus:border-transparent text-sm"
                />
                {brochureError && (
                  <p className="text-red-400 text-xs">{brochureError}</p>
                )}
                <label className="flex items-start space-x-2 cursor-pointer">
                  <input
                    data-testid="brochure-privacy-checkbox"
                    type="checkbox"
                    checked={brochurePrivacy}
                    onChange={(e) => setBrochurePrivacy(e.target.checked)}
                    className="mt-0.5 w-4 h-4 accent-[#E67E22] flex-shrink-0"
                  />
                  <span className="text-white/70 text-xs leading-relaxed">
                    Ho letto l'<Link to="/privacy-policy" className="underline text-white/90">Informativa Privacy</Link> e acconsento al trattamento dei miei dati per ricevere la brochure. *
                  </span>
                </label>
                <button
                  type="submit"
                  disabled={brochureSubmitting}
                  className="w-full bg-gradient-to-r from-[#E67E22] to-[#E74C3C] text-white font-semibold py-2 rounded-lg hover:shadow-lg transition-all duration-300 disabled:opacity-50 flex items-center justify-center"
                >
                  {brochureSubmitting ? (
                    <span>Invio in corso...</span>
                  ) : (
                    <>
                      <Download className="w-4 h-4 mr-2" />
                      Scarica Brochure
                    </>
                  )}
                </button>
                <p className="text-white/50 text-xs text-center">
                  I tuoi dati sono al sicuro. Niente spam.
                </p>
              </form>
            ) : (
              <div className="text-center py-4">
                <CheckCircle className="w-12 h-12 text-[#5FB76E] mx-auto mb-3" />
                <p className="text-white font-medium mb-3">Grazie per la richiesta!</p>
                <a
                  href="https://www.assieticagest.it/brochure"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#5FB76E] to-[#3AAFA9] text-white font-semibold rounded-lg hover:shadow-lg transition-all duration-300"
                >
                  <Download className="w-5 h-5 mr-2" />
                  Scarica la Brochure
                </a>
              </div>
            )}
          </div>

          {/* Demo Access Modal */}
          {showDemoModal && (
            <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 relative animate-fade-in">
                <button 
                  onClick={() => {
                    setShowDemoModal(false);
                    setDemoPassword('');
                    setDemoError('');
                    setShowCredentials(false);
                  }}
                  className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>

                {!showCredentials ? (
                  <>
                    <div className="text-center mb-6">
                      <div className="w-16 h-16 bg-[#5FB76E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-8 h-8 text-[#5FB76E]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                      </div>
                      <h3 className="text-xl font-bold text-gray-800">Accesso Area Demo</h3>
                      <p className="text-gray-500 text-sm mt-2">Inserisci la password per accedere alla demo del Gestionale ETS</p>
                    </div>

                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Password di accesso</label>
                        <input
                          type="password"
                          value={demoPassword}
                          onChange={(e) => {
                            setDemoPassword(e.target.value);
                            setDemoError('');
                          }}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                              if (demoPassword === 'strongpassword123') {
                                setShowCredentials(true);
                                setDemoError('');
                              } else {
                                setDemoError('Password non valida');
                              }
                            }
                          }}
                          className={`w-full px-4 py-3 border ${demoError ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-[#5FB76E] focus:border-transparent bg-white text-gray-900`}
                          placeholder="Inserisci password..."
                          autoFocus
                        />
                        {demoError && <p className="text-red-500 text-sm mt-1">{demoError}</p>}
                      </div>

                      <button
                        onClick={() => {
                          if (demoPassword === 'strongpassword123') {
                            setShowCredentials(true);
                            setDemoError('');
                          } else {
                            setDemoError('Password non valida');
                          }
                        }}
                        className="w-full bg-gradient-to-r from-[#5FB76E] to-[#3AAFA9] text-white font-semibold py-3 rounded-lg hover:shadow-lg transition-all duration-300"
                      >
                        Accedi alla Demo
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="text-center mb-6">
                      <div className="w-16 h-16 bg-[#5FB76E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-8 h-8 text-[#5FB76E]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <h3 className="text-xl font-bold text-gray-800">Credenziali Demo</h3>
                      <p className="text-gray-500 text-sm mt-2">Usa queste credenziali per accedere al Gestionale ETS</p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-4 space-y-3">
                      <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Utente</label>
                        <div className="flex items-center justify-between bg-white border border-gray-200 rounded-lg px-4 py-2">
                          <span className="font-mono text-gray-800">demo@assieticagest.it</span>
                          <button 
                            onClick={() => navigator.clipboard.writeText('demo@assieticagest.it')}
                            className="text-[#5FB76E] hover:text-[#3AAFA9] transition-colors"
                            title="Copia"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 mb-1">Password</label>
                        <div className="flex items-center justify-between bg-white border border-gray-200 rounded-lg px-4 py-2">
                          <span className="font-mono text-gray-800">DemoFree2026!</span>
                          <button 
                            onClick={() => navigator.clipboard.writeText('DemoFree2026!')}
                            className="text-[#5FB76E] hover:text-[#3AAFA9] transition-colors"
                            title="Copia"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>

                    <a
                      href="https://volongest.it"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-6 w-full bg-gradient-to-r from-[#5FB76E] to-[#3AAFA9] text-white font-semibold py-3 rounded-lg hover:shadow-lg transition-all duration-300 flex items-center justify-center"
                    >
                      Vai al Gestionale
                      <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </a>

                    <p className="text-center text-gray-400 text-xs mt-4">
                      Ambiente dimostrativo con dati fittizi
                    </p>
                  </>
                )}
              </div>
            </div>
          )}

          {/* Copyright & Links */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60">
              © {new Date().getFullYear()} Assietica Società Cooperativa. Tutti i diritti riservati.
            </p>
            <div className="flex flex-wrap gap-6 text-sm">
              <Link to="/privacy-policy" className="text-white/60 hover:text-white transition-colors duration-300">
                Privacy Policy
              </Link>
              <Link to="/cookie-policy" className="text-white/60 hover:text-white transition-colors duration-300">
                Cookie Policy
              </Link>
              <Link to="/reclami" className="text-white/60 hover:text-white transition-colors duration-300">
                Reclami
              </Link>
              <Link to="/termini-condizioni" className="text-white/60 hover:text-white transition-colors duration-300">
                Note Legali
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
